// extracted by mini-css-extract-plugin
export default {"root":"VoiceRoom_root__HlFFZ","fixed":"VoiceRoom_fixed__cS9ZM"};